import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "pt-8 bg-white flex flex-col text-12px xxl:text-14px overflow-hidden h-screen relative w-full pr-5 sm:pr-0" }
const _hoisted_2 = {
  class: "px-4 py-3 flex flex-row items-center rounded-lg w-full mb-3",
  style: {"background-color":"#f5f5f5","box-shadow":"0px 1px 4px 0px rgba(26, 20, 33, 0.15)"}
}
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "text-14px font-normal font-montserrat text-gray-lp-300" }, [
  /*#__PURE__*/_createVNode("strong", null, " PENTING! "),
  /*#__PURE__*/_createTextVNode(" Cari dan pilih nama klien dulu "),
  /*#__PURE__*/_createVNode("strong", null, " sebelum membuat manifest. ")
], -1)
const _hoisted_4 = { class: "flex flex-row items-center justify-between my-4" }
const _hoisted_5 = { class: "flex flex-row gap-x-3 w-3/5" }
const _hoisted_6 = { class: "flex h-screen justify-center overflow-auto" }
const _hoisted_7 = { class: "overflow-y-auto" }
const _hoisted_8 = { class: "hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_SelectSearchV2 = _resolveComponent("SelectSearchV2")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_TableV2 = _resolveComponent("TableV2")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Icons, {
        width: "24",
        height: "24",
        class: "mr-2",
        name: "warning-circle",
        color: "#C64D51"
      }),
      _hoisted_3
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_SelectSearchV2, {
          onFilter: _ctx.onSearchListPosCbp,
          onFocus: _ctx.onSearchListPosCbp,
          isLoading: _ctx.isLoadingPosCbp,
          options: _ctx.posCbp,
          keyName: "name",
          keyValue: "id",
          placeholder: "Cari nama klien",
          modelValue: _ctx.filter.pmcClientId,
          "onUpdate:modelValue": [
            _cache[1] || (_cache[1] = ($event: any) => (_ctx.filter.pmcClientId = $event)),
            _ctx.onSelectPosCbp
          ]
        }, null, 8, ["onFilter", "onFocus", "isLoading", "options", "modelValue", "onUpdate:modelValue"]),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.statusPrintManifest, (tab) => {
          return (_openBlock(), _createBlock("div", {
            key: tab.label,
            class: `
          rounded-2xl
          text-14px
          xxl:text-16px
          py-2
          px-4
          text-center
          items-center
          self-center
          font-montserrat
          ${
            _ctx.isTabActive(tab.value)
              ? 'bg-red-lp-100 text-white'
              : 'bg-white border border-red-lp-100 text-red-lp-100'
          }
          cursor-pointer
          whitespace-nowrap
        `,
            onClick: ($event: any) => (_ctx.changeStatusPrintManifest(tab.value))
          }, _toDisplayString(tab.label), 11, ["onClick"]))
        }), 128))
      ]),
      (_ctx.isAbleCreateManifest)
        ? (_openBlock(), _createBlock(_component_LpButton, {
            key: 0,
            customClass: "py-2",
            disabled: _ctx.disabledCreateManifest,
            textColor: "white",
            onClick: _ctx.onPrintManifest,
            title: "Buat Manifest"
          }, null, 8, ["disabled", "onClick"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode("div", _hoisted_7, [
        _createVNode(_component_TableV2, {
          loading: _ctx.apiListData.loading,
          borderTop: false,
          borderBottom: false,
          columns: _ctx.columns,
          data: _ctx.listData.data,
          isEmpty: _ctx.isEmpty,
          emptyHeaderMessage: "Tidak Ada Daftar Booking Klien CBP",
          emptyMessage: "Mulai buat Daftar Booking Klien CBP dan cek daftarnya disini",
          errorCause: _ctx.apiListData.errorType,
          onClick: ($event: any) => (
            {
            }
          ),
          isDetailAble: "",
          pagination: _ctx.listData.pagination,
          "onUpdate:pagination": _cache[2] || (_cache[2] = ($event: any) => (_ctx.listData.pagination = $event)),
          onRequest: _ctx.getListClientCBP,
          onTryAgain: _ctx.getListClientCBP,
          paginationStyle: "v3",
          isPinnedScrollBottom: "",
          pinnedSubstractHeight: "360px"
        }, null, 8, ["loading", "columns", "data", "isEmpty", "errorCause", "pagination", "onRequest", "onTryAgain"])
      ])
    ]),
    _createVNode("div", _hoisted_8, [
      _createVNode("img", {
        id: "logo",
        src: require(`@/app/ui/assets/images/logo-${_ctx.roleAccount}.png`),
        class: "hidden",
        alt: "logo"
      }, null, 8, ["src"])
    ])
  ]))
}